import React, { Component } from 'react';
import SelectInput from './SelectInput';
import './index.css';
import withViewContext from './withViewContext';

class USStateInput extends Component {
  constructor(props) {
    super(props);

    this.options = [
      { id: '', value: '- Please select -' },
      {
        id: 'AL',
        value: 'AL',
      },
      {
        id: 'AK',
        value: 'AK',
      },
      {
        id: 'AS',
        value: 'AS',
      },
      {
        id: 'AZ',
        value: 'AZ',
      },
      {
        id: 'AR',
        value: 'AR',
      },
      {
        id: 'CA',
        value: 'CA',
      },
      {
        id: 'CO',
        value: 'CO',
      },
      {
        id: 'CT',
        value: 'CT',
      },
      {
        id: 'DE',
        value: 'DE',
      },
      {
        id: 'DC',
        value: 'DC',
      },
      {
        id: 'FM',
        value: 'FM',
      },
      {
        id: 'FL',
        value: 'FL',
      },
      {
        id: 'GA',
        value: 'GA',
      },
      {
        id: 'GU',
        value: 'GU',
      },
      {
        id: 'HI',
        value: 'HI',
      },
      {
        id: 'ID',
        value: 'ID',
      },
      {
        id: 'IL',
        value: 'IL',
      },
      {
        id: 'IN',
        value: 'IN',
      },
      {
        id: 'IA',
        value: 'IA',
      },
      {
        id: 'KS',
        value: 'KS',
      },
      {
        id: 'KY',
        value: 'KY',
      },
      {
        id: 'LA',
        value: 'LA',
      },
      {
        id: 'ME',
        value: 'ME',
      },
      {
        id: 'MH',
        value: 'MH',
      },
      {
        id: 'MD',
        value: 'MD',
      },
      {
        id: 'MA',
        value: 'MA',
      },
      {
        id: 'MI',
        value: 'MI',
      },
      {
        id: 'MN',
        value: 'MN',
      },
      {
        id: 'MS',
        value: 'MS',
      },
      {
        id: 'MO',
        value: 'MO',
      },
      {
        id: 'MT',
        value: 'MT',
      },
      {
        id: 'NE',
        value: 'NE',
      },
      {
        id: 'NV',
        value: 'NV',
      },
      {
        id: 'NH',
        value: 'NH',
      },
      {
        id: 'NJ',
        value: 'NJ',
      },
      {
        id: 'NM',
        value: 'NM',
      },
      {
        id: 'NY',
        value: 'NY',
      },
      {
        id: 'NC',
        value: 'NC',
      },
      {
        id: 'ND',
        value: 'ND',
      },
      {
        id: 'MP',
        value: 'MP',
      },
      {
        id: 'OH',
        value: 'OH',
      },
      {
        id: 'OK',
        value: 'OK',
      },
      {
        id: 'OR',
        value: 'OR',
      },
      {
        id: 'PW',
        value: 'PW',
      },
      {
        id: 'PA',
        value: 'PA',
      },
      {
        id: 'PR',
        value: 'PR',
      },
      {
        id: 'RI',
        value: 'RI',
      },
      {
        id: 'SC',
        value: 'SC',
      },
      {
        id: 'SD',
        value: 'SD',
      },
      {
        id: 'TN',
        value: 'TN',
      },
      {
        id: 'TX',
        value: 'TX',
      },
      {
        id: 'UT',
        value: 'UT',
      },
      {
        id: 'VT',
        value: 'VT',
      },
      {
        id: 'VI',
        value: 'VI',
      },
      {
        id: 'VA',
        value: 'VA',
      },
      {
        id: 'WA',
        value: 'WA',
      },
      {
        id: 'WV',
        value: 'WV',
      },
      {
        id: 'WI',
        value: 'WI',
      },
      {
        id: 'WY',
        value: 'WY',
      },
    ];
  }

  render() {
    const { props, options } = this;
    return <SelectInput {...props} options={options} />;
  }
}

export default withViewContext(USStateInput);
